import { useEffect } from 'react';

export const useStylesheet = (href: string, enabled: boolean) => {
    useEffect(() => {
        if (!enabled) return;

        const link = document.createElement('link');

        link.rel = 'stylesheet';
        link.href = href;

        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [href, enabled]);
};
